import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Input from '@material-ui/core/Input';

class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            hasFocus: false,
        };

        this.lastTimeout = null;
    }

    static getDerivedStateFromProps(props, state) {
        if (state.hasFocus) {
            return {};
        }
        return { value: props.value };
    }

    componentWillUnmount() {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = undefined;
    }

    onChange = event => {
        clearTimeout(this.lastTimeout);

        const value = event.target.value;
        this.setState({ value: value });

        this.lastTimeout = setTimeout(() => this.props.onChange(value), 500);
    };

    onFocus = () => {
        this.setState({ hasFocus: true });
        const { onFocus } = this.props;
        if (onFocus) {
            onFocus();
        }
    };

    onBlur = () => {
        this.setState({ hasFocus: false });
        const { onBlur } = this.props;
        if (onBlur) {
            onBlur();
        }
    };

    render() {
        const { showIcon, placeholder, classes } = this.props;
        return (
            <div className={classes.wrapper}>
                {showIcon && <i className={classes.icon}>search</i>}
                <Input
                    placeholder={placeholder}
                    value={this.state.value}
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    autoFocus={true}
                    disableUnderline
                />
            </div>
        );
    }
}

Search.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    showIcon: PropTypes.bool,
};

Search.defaultProps = {
    onFocus: undefined,
    onBlur: undefined,
    placeholder: 'Search...',
    showIcon: true,
};

const style = ({ palette, spacing }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
    },
    icon: {
        composes: ['material-icons'],
        marginRight: spacing.unit * 2,
        color: palette.text.secondary,
    },
});

export default injectSheet(style)(Search);



// WEBPACK FOOTER //
// ./src/components/search/Search.js